import { Tag } from './generated/graphql';

export enum RouteType {
    None,
    Admin,
    Main,
}

export type FilterTag = Tag & { inverse?: boolean };